import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export enum TokenType {
  CENTRAL_AD_HOC = 'CENTRAL_AD_HOC',
  CENTRAL_APP = 'CENTRAL_APP',
  CENTRAL = 'CENTRAL',
  EMAID = 'EMAID',
  ISO_14443 = 'ISO_14443',
  ISO_15693 = 'ISO_15693',
  KEY_CODE = 'KEY_CODE',
  LOCAL = 'LOCAL',
  MAC_ADDRESS = 'MAC_ADDRESS'
}

export interface StartTransactionCommand {
  evseId: number;
  identifyingToken: {
    token: string;
    tokenType?: TokenType; // Relevant for OCPP 2.0.1 only.
  };
}

const client = createClient('/rest/operator-api/charging-stations');

export const startTransaction: SaveOperation<StartTransactionCommand, void, string> = postRequestFactory<
  StartTransactionCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/start-transaction',
  permissionId: commandPermissions.START_TRANSACTION
});
